module.exports = __webpack_public_path__ + "img/icon-iv.756aa0d0.svg";